import { AddChildDetails } from 'Pages/CaregiverPortal/InterestForm/Step1/AddChildDetails'
import { type EnrollmentDetails } from 'core/types'
import { ProviderSelection } from 'Pages/CaregiverPortal/InterestForm/Step1/ProviderSelection'
import { ChildrenSummary } from 'Pages/CaregiverPortal/InterestForm/Step1/ChildrenSummary'

export interface ChildDetailsStepProps {
  handleStep: (backwards: boolean) => void
  caregiverForm: EnrollmentDetails
}

export function ChildDetailsStep (props: ChildDetailsStepProps): JSX.Element {
  const caregiverForm = props.caregiverForm

  if (caregiverForm.currentSubStep === 1) {
    return <ProviderSelection caregiverForm={caregiverForm} />
  } else if (caregiverForm.currentSubStep === 2) {
    return <AddChildDetails caregiverForm={caregiverForm} />
  } else if (caregiverForm.currentSubStep === 3) {
    return <ChildrenSummary caregiverForm={caregiverForm} handleStep={props.handleStep} />
  }

  return <></>
}
